export default __webpack_public_path__ + "static/media/nextIcon.95217a0e.svg";